import * as React from "react";
import {Form, Input, Button} from "antd";
import {Link} from "@netless/i18n-react-router";
import queryString from "query-string";
import {observer} from "mobx-react";
import {RouteComponentProps, withRouter} from "react-router";
import {injectIntl, InjectedIntlProps} from "react-intl";
import {loginStore} from "../../models/LoginStore";
import LoginLayout from "../LoginLayout";
import {consoleApi} from "src/apiMiddleware";
import {miniPersistStore} from "src/models/MiniPersistStore";

const FormItem = Form.Item;
export type RegisterProps = RouteComponentProps<{}> & InjectedIntlProps;

export type LoginStates = {
    email: string | null;
    password: string | null;
};

@observer
class Login extends React.Component<RegisterProps, LoginStates> {

    public constructor(props: RegisterProps) {
        super(props);
        this.state = {
            email: null,
            password: null,
        };
    }

    public async componentDidMount(): Promise<void> {
        const parsed = queryString.parse(location.search);
        const return_to = parsed.return_to;
        if (miniPersistStore.token) {
            if (return_to) {
                await consoleApi.user.ssoUserData({token: miniPersistStore.token});
            } else {
                this.props.history.push("/");
            }
        }
    }

    private handleSubmit = async (values: any): Promise<void> => {
        const parsed = queryString.parse(location.search);
        let return_to = parsed.return_to;
        if (return_to) {
            return_to = "https://support.netless.link/";
            const ssoResult = await consoleApi.user.ssoUserData({
                email: values.email,
                password: values.password,
                url: return_to,
            });
            console.log(ssoResult);
            if (ssoResult.data.url) {
                window.location.href = ssoResult.data.url;
            }
        } else {
            await loginStore.login(this.props.history, values.email, values.password);
        }
    }

    public render(): React.ReactNode {
        const {intl} = this.props;
        return (
            <LoginLayout>
                <div className="login-title">{intl.formatMessage({id: "title"})}</div>
                <Form onFinish={this.handleSubmit} className="login-form">
                    <FormItem
                        name={"email"}
                        rules={[
                            {
                                type: "email", message: intl.formatMessage({id: "global.not-email-message"}),
                            },
                            {
                                required: true, message: intl.formatMessage({id: "global.please-input-email"}),
                            }]}
                    >
                        <Input size={"large"} onChange={evt => this.setState({email: evt.target.value})}
                               placeholder={intl.formatMessage({id: "global.email-login"})}/>
                    </FormItem>
                    <FormItem
                        name="password"
                        rules={[{required: true, message: intl.formatMessage({id: "input-password"})}]}
                    >
                        <Input.Password size={"large"} />
                    </FormItem>
                    <FormItem>
                        <div className="login-form-button-box">
                            <Button
                                type="primary"
                                size="large"
                                htmlType="submit"
                                loading={loginStore.loginLoadingState}
                                className="login-form-button">
                                {intl.formatMessage({id: "title"})}
                            </Button>
                            {this.state.email === null ? <Link to={"/email-account-verification/"}>
                                    <div
                                        className="login-form-text">
                                        {intl.formatMessage({id: "retrieve-password"})}
                                    </div>
                                </Link> :
                                <Link to={`/email-account-verification/${this.state.email}/`}>
                                    <div
                                        className="login-form-text">
                                        {intl.formatMessage({id: "retrieve-password"})}
                                    </div>
                                </Link>
                            }
                        </div>
                    </FormItem>
                </Form>
                <div className="login-under">
                    <span style={{marginRight: 4}}>
                        {intl.formatMessage({id: "script"})}
                    </span>
                    <a href="https://sso.agora.io/cn/signup">
                        {intl.formatMessage({id: "register"})}
                    </a>
                </div>
            </LoginLayout>
        );
    }
}

export default withRouter(injectIntl(Login));



// WEBPACK FOOTER //
// ./src/components/user/Login.tsx